import React, { Component } from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { AssetProps } from './Helpers';

import StoryCard, { variations as storyCardVariations } from './StoryCard';
import ProductCarouselSliderContainer from '../shopping/ProductCarouselSlider';

export default class ShopByTheme extends Component {
  renderStoryCard() {
    const {
      bodyFontSize,
      className,
      images,
      header,
      copy,
      richTextCopy,
      points,
      links,
      align,
      verticalAlign,
      overlayColor,
      textColor,
    } = this.props;

    const storyCardLinks = links?.map((link) => ({
      ...link,
      className: link.className || 'link',
    }));

    return (
      <div className="shop-theme__story-card">
        <StoryCard
          bodyFontSize={bodyFontSize || 'XL'}
          className={className}
          variation={storyCardVariations.WIDER_ASSET}
          images={images}
          header={header}
          overlayColor={overlayColor}
          textColor={textColor}
          copy={copy}
          align={align || 'right'}
          verticalAlign={verticalAlign}
          richTextCopy={richTextCopy}
          points={points}
          links={storyCardLinks}
        />
      </div>
    );
  }

  renderProductCarousel() {
    const {
      history,
      collections,
    } = this.props;
    const items = collections?.[0]?.productCollectionItems;

    return items?.length && (
      <div className="shop-theme__carousel">
        <ProductCarouselSliderContainer
          productCollectionItems={items}
          history={history}
        />
      </div>
    );
  }

  render() {
    const {
      type,
    } = this.props;
    return (
      <section className={classNames('shop-theme', type)}>
        {this.renderStoryCard()}
        {this.renderProductCarousel()}
      </section>
    );
  }
}

ShopByTheme.defaultProps = {
  align: 'right',
  collections: [],
  hideDetails: false,
  hideShoppingLink: false,
  hideColorPicker: false,
  type: 'ShopByTheme',
};

const productCollectionItemShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  item: PropTypes.shape({}),
  sku: PropTypes.string,
});

const productCollectionShape = PropTypes.shape({
  productCollectionItems: PropTypes.arrayOf(productCollectionItemShape),
});

ShopByTheme.propTypes = {
  images: PropTypes.arrayOf(AssetProps),
  header: PropTypes.string,
  copy: PropTypes.string,
  richTextCopy: PropTypes.shape({
    markdown: PropTypes.string,
  }),
  links: PropTypes.array,
  align: PropTypes.string,
  verticalAlign: PropTypes.string,
  overlayColor: PropTypes.object,
  textColor: PropTypes.object,
  collections: PropTypes.arrayOf(productCollectionShape),
  type: PropTypes.string,
};
